import { Hash } from "viem";
import { CheckmarkFilledIcon, ModalLegacy, ModalLegacyProps } from "@looksrare/uikit";
import { useTranslation } from "next-i18next";
import { RaffleUnclaimedPrize } from "views/win/userGeneratedRaffles/types";
import { ClaimView } from "./ClaimView";
import { CompleteView } from "./CompleteView";

interface ClaimWinningsModalProps extends Omit<ModalLegacyProps, "children"> {
  unclaimedPrizes: RaffleUnclaimedPrize[];
  isTxConfirmed: boolean;
  txHash?: Hash | null;
}

export const ClaimWinningsModal = ({ unclaimedPrizes, isTxConfirmed, txHash, ...props }: ClaimWinningsModalProps) => {
  const { t } = useTranslation();
  return (
    <ModalLegacy
      title={isTxConfirmed ? t("Winnings Claimed") : t("Claim Winnings")}
      heroElement={isTxConfirmed && <CheckmarkFilledIcon boxSize={16} color="interactive-03" />}
      label={isTxConfirmed ? t("Your winnings are now in your wallet") : ""}
      {...props}
    >
      {!!isTxConfirmed ? (
        <CompleteView onClose={props.onClose} />
      ) : (
        <ClaimView unclaimedPrizes={unclaimedPrizes} transactionHash={txHash} />
      )}
    </ModalLegacy>
  );
};
